import { animate, query, style, transition, trigger } from '@angular/animations';

/**
 * Conexa Flow route transition: the entering page fades in while rising 12px.
 *
 * Angular's animation DSL cannot read CSS custom properties, so the timing below hardcodes the
 * motion tokens from styles.scss - keep them in sync if the tokens ever change:
 *   --motion-slow: 320ms; --ease-emphasized: cubic-bezier(0.05, 0.7, 0.1, 1)
 *
 * Wiring (app.component): the trigger binds on a wrapper around the top-level router-outlet,
 * keyed on the activated route (standard outlet-data pattern), and is gated with [@.disabled]
 * for prefers-reduced-motion users.
 *
 * Design notes:
 * - Only transform/opacity are animated (Conexa Flow hard constraint 8).
 * - The outgoing page is taken out of flow instantly (display: none) so the entering page
 *   never stacks beneath it - no absolute-position overlay tricks, no layout thrash.
 * - Both queries are optional: a trigger-value change with no top-level component swap
 *   (e.g. navigation inside a lazy module) is a silent no-op.
 */
export const routeFadeUp = trigger('routeFadeUp', [
    transition('* => *', [
        query(':leave', style({ display: 'none' }), { optional: true }),
        query(':enter', [
            style({ opacity: 0, transform: 'translateY(12px)' }),
            animate('320ms cubic-bezier(0.05, 0.7, 0.1, 1)',
                style({ opacity: 1, transform: 'translateY(0)' }))
        ], { optional: true })
    ])
]);
